<template>
    <div class="ims-box">
        <div v-if="slotExists('left')" class="box-left">
            <slot name="left"></slot>
        </div>
        <slot></slot>
        <div v-if="slotExists('right')" class="box-right">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        methods:{
            slotExists(name) {
                if (name) {
                    return this.$slots.hasOwnProperty(name);
                } else {
                    return this.$slots.hasOwnProperty("default");
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/utils/variables";
    @import "../../scss/vendors/bootstrap-utils";

    .ims-box{
        background-color:#fff;
        display:flex;
        justify-content:center;
        align-items:center;
    }

    .ims-box .box-left{ margin-right:auto; }
    .ims-box .box-right{ margin-left:auto; }

    .ims-box > *:last-child{
        margin-bottom:0;
    }

</style>